import { findElements, createElement } from 'dom-helper';
import URLBuilder from 'url-builder';
import PathHelper from '../utils/path-helper';
import ENV from '../config/env';
import POSTER_BRICK_VERSION from '../../../gwi-brick/src/config/version';

export default class AssetsService {
  static getStylesheetElement(url) {
    const stylesheet = createElement('link');

    stylesheet.href = url;
    stylesheet.rel = 'stylesheet';

    return stylesheet;
  }

  static appendBrickAssets() {
    const js = createElement('script');
    const body = findElements('body')[0];

    const brickPath = PathHelper.getBrickPath(ENV.posterBrickPath, POSTER_BRICK_VERSION);

    const brickPaintStylesheetUrl = URLBuilder.buildUrl(ENV.brickHost, `${brickPath}/brick-paint.css`);
    const brickPaintStylesheet = AssetsService.getStylesheetElement(brickPaintStylesheetUrl);

    const openSansFontStylesheet = AssetsService.getStylesheetElement('https://fonts.googleapis.com/css?family=Open+Sans');
    const fontAwesomeStylesheet = AssetsService.getStylesheetElement('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

    js.async = true;
    js.src = URLBuilder.buildUrl(ENV.brickHost, `${brickPath}/brick.js`);

    body.appendChild(js);
    body.appendChild(openSansFontStylesheet);
    body.appendChild(fontAwesomeStylesheet);
    body.appendChild(brickPaintStylesheet);
  }
}



// WEBPACK FOOTER //
// ./src/services/assets-service.js